  <div *ngIf="!isExternalCompany" class="row mb-3">
    <div class="col-6">
      <div class="_buttons">
        <a *ngIf="'Recruitments' | hasPermission:'create'" routerLink="/hr/recruitments/create" class="btn btn-success me-2">
          <i class="fa fa-plus"></i>&nbsp;
          {{'New Recruitment Campaign' | translate}}
        </a>
      </div>
    </div>
    <div class="col-6">
      <label for="search">{{ 'Search by recruitment' | translate }}</label>
      <div class="input-group search-container">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="Search" 
          [(ngModel)]="searchText">
      
        <!-- Confirm (Green) Button -->
        <button class="btn btn-success" type="button" (click)="applyFilter()">
          <i class="fas fa-check"></i>
        </button>
      
        <!-- Clear (Red) Button -->
        <button class="btn btn-danger" type="button" (click)="clearSearch()">
          <i class="fas fa-times"></i>
        </button>
      </div>      
    </div>
  </div>
  
  <div class="card">
    <div class="card-header">
      <div class="row row-cols-1 row-cols-md-3 row-cols-lg-6 g-2">
        <div *ngFor="let status of recruitmentDataService.getRecruitmentCounts()" class="col">
          <div class="border border-gray-300 d-flex flex-grow-1 align-items-center p-3">
            <span class="font-weight-bold me-3 ms-md-3 text-lg">{{ status.count }}</span>
            <span class="text-{{ status.colorClass }} text-truncate">{{ status.status | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  
    <div class="card-body">
      <div *ngIf="filteredRecruitments.length > 0; else noDataFound">
        <div class="row g-3">
          <div *ngFor="let recruitment of filteredRecruitments | slice: (page-1)*pageSize : page*pageSize" class="col-md-{{ !isExternalCompany ? '6' : '4'}}">
            <div class="card h-100">
              
              <!-- Card Header: Position Name -->
              <div class="card-header bg-{{recruitmentDataService.getColorByStatus(recruitment.status)}} text-white" style="position: relative;">
                <i class="fa fa-briefcase me-2"></i> {{ recruitment.campaign_name }}
              </div>
    
              <!-- Card Body -->
              <div class="card-body" style="padding: 1rem;">
                <!-- Company Info -->
                <p><i class="fa fa-building me-2"></i> {{'Department' | translate}}: {{ recruitment.department?.name }}</p>
                <p><i class="fa fa-map-marker me-2"></i> {{'Location' | translate}}: {{ recruitment.workplace || 'N/A' }}</p>
                <p><i class="fa fa-user me-2"></i> {{'Age' | translate}}: {{ recruitment.age_from }} - {{recruitment.age_to}} {{ 'Years' | translate }}</p>
                <span class="badge bg-{{recruitmentDataService.getColorByStatus(recruitment.status)}} position-absolute top-4 end-0 m-2">{{ recruitment.status | translate }}</span>
                <!-- Openings Info with Highlight -->
                <p class="text-primary font-weight-bold"><i class="fa fa-users me-2"></i> {{'Open Positions' | translate}}: {{ recruitment.quantity }}</p>
    
                <!-- Number of Candidates with Highlight -->
                <p *ngIf="!isExternalCompany" class="text-info font-weight-bold"><i class="fa fa-users me-2"></i> {{'Candidates' | translate}}: {{ recruitment.candidates.length || 0 }}</p>
    
                <!-- Image -->
                <div class="d-flex justify-content-center">
                  <img [src]="recruitment.banner?.url" 
                      alt="Office environment" 
                      class="img-fluid mb-3" 
                      width="300" height="200">
                </div>
                <!-- Salary Range -->
                <div class="price">
                  <i class="fa fa-dollar-sign me-2"></i> 
                  {{ recruitment.starting_salary_from | number }} - {{ recruitment.starting_salary_to | number }} {{ currency?.symbol }}
                </div>
    
                <!-- Skills -->
                <div class="skills mt-2">
                  <span><strong>{{'Skills' | translate}}:</strong></span>
                  <span *ngFor="let skill of recruitment.required_skills" [attr.title]="skill.name" class="badge bg-secondary ms-1">{{ skill.name | slice:0-20 }}</span>
                </div>
              </div>
    
              <!-- Card Footer: Actions -->
              <div class="actions card-footer d-flex justify-content-around align-items-center">
                <button *ngIf="'Recruitments Campaigns' | hasPermission:'delete'" (click)="onDelete(recruitment.id)" type="button" class="dropdown-item">
                  <i class="fa fa-trash"></i> {{'Delete' | translate}}
                </button>
                <button *ngIf="'Recruitments Campaigns' | hasPermission:'update'"  [routerLink]="['/hr/recruitments/edit', recruitment.id]" class="dropdown-item">
                  <i class="fa fa-edit"></i> {{'Edit' | translate}}
                </button>
                <button *ngIf="'Recruitments Campaigns' | hasPermission:'read'" [routerLink]="['/hr/recruitments/details', recruitment.id]" class="dropdown-item">
                  <i class="fa fa-eye"></i> {{'Actions' | translate}}
                </button>
                <button *ngIf="'Recruitments Campaigns' | hasPermission:'read'"  [routerLink]="['/hr/recruitments/job-details', recruitment.id]" class="dropdown-item">
                  <i class="fa fa-info"></i> {{'Job Details' | translate}}
                </button>
                <button *ngIf="isExternalCompany" (click)="showCandidateForm(recruitment)" class="dropdown-item">
                  <i class="fa fa-user-plus"></i> {{'Add Candidate to Job' | translate}}
                </button>
                <button *ngIf="!isExternalCompany" type="button" class="dropdown-item" 
                      [ngbPopover]="popoverContent" 
                      popoverTitle="{{ 'Share this Recruitment' | translate }}" 
                      [popoverContext]="{ recruitmentId: recruitment.id }"
                      triggers="click" 
                      #p="ngbPopover">
                  <i class="fa fa-share-alt"></i> {{'Share' | translate}}
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Pagination -->
      <div class="d-flex justify-content-end mt-3">
        <ngb-pagination 
          [(page)]="page" 
          [pageSize]="pageSize" 
          [collectionSize]="filteredRecruitments.length" 
          (pageChange)="onPageChange($event)">
        </ngb-pagination>
      </div>
      <!-- No Data Found Message -->
      <ng-template #noDataFound>
        <div class="text-center text-muted mt-3">
          <i class="fa fa-exclamation-circle fa-3x"></i>
          <p class="mt-2">{{ 'No recruitment data available' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </div>

  <!-- Popover Content for Job Portals -->
  <ng-template #popoverContent let-recruitmentId="recruitmentId">
    <div class="d-flex flex-wrap justify-content-between">
        <!-- <button class="btn btn-indeed btn-link d-flex align-items-center" [disabled]="true">
            <i class="fa fa-check-square me-2"></i> {{ 'Indeed' }}
        </button>
        <button class="btn btn-monster btn-link d-flex align-items-center" [disabled]="true">
            <i class="fa fa-flag me-2"></i> {{ 'Monster' }}
        </button>
        <button class="btn btn-glassdoor btn-link d-flex align-items-center" [disabled]="true">
            <i class="fa fa-star me-2"></i> {{ 'Glassdoor' }}
        </button> -->
        <button class="btn btn-linkedin btn-link d-flex align-items-center" (click)="share(recruitmentId)">
            <i class="fab fa-linkedin me-2"></i> {{ 'LinkedIn' }}
        </button>
        <!-- <button class="btn btn-simplyhired btn-link d-flex align-items-center" [disabled]="true">
            <i class="fa fa-search me-2"></i> {{ 'SimplyHired' }}
        </button>
        <button class="btn btn-ziprecruiter btn-link d-flex align-items-center" [disabled]="true">
            <i class="fa fa-paper-plane me-2"></i> {{ 'ZipRecruiter' }}
        </button> -->
    </div>
</ng-template>



  <ng-template #candidateFormModal>
    <div class="modal-header">
      <h5 class="modal-title">{{ 'Add Candidates' | translate }}</h5>
      <button type="button" class="btn-close" (click)="closeCandidateForm()"></button>
    </div>
    <div class="modal-body">
      <form #form="ngForm">
        <div class="form-group">
          <label for="candidateId">{{ 'Candidates' | translate }}</label>
          <ng-select 
            [items]="candidatesDropdown" 
            bindLabel="name" 
            bindValue="id"
            id="candidateId" 
            name="candidateId" 
            [(ngModel)]="candidateId" 
            required>
          </ng-select>
          <div *ngIf="form.submitted && !candidateId" class="text-danger">
            {{ 'Candidate selection is required.' | translate }}
          </div>
        </div>
        
        <div class="mb-3">
          <label for="attachment">{{ 'Attachment' | translate }}</label>
          <input type="file" class="form-control" (change)="onFileChange($event)">
          <a *ngIf="document" target="_blank" [href]="document?.url">{{ 'Open File' | translate }}</a>
        </div>
      </form>                 
    </div>
    <div class="modal-footer">
      <button type="button" (click)="save()" class="btn btn-primary pull-right" [disabled]="!form.valid">{{ 'Submit' | translate }}</button>
    </div>
  </ng-template>
  